var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 3.2a6.8 6.8 0 0 0-5.115 11.281 5.72 5.72 0 0 1 2.724-2.657 3.7 3.7 0 1 1 4.781 0 5.72 5.72 0 0 1 2.725 2.657A6.8 6.8 0 0 0 10 3.2m4.024 12.282a4.302 4.302 0 0 0-8.048 0A6.77 6.77 0 0 0 10 16.8a6.77 6.77 0 0 0 4.024-1.318M1.8 10a8.2 8.2 0 1 1 16.4 0 8.2 8.2 0 0 1-16.4 0M10 6.7a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6",
    clipRule: "evenodd"
  })));
};
export default SvgUser;